module.exports = __webpack_public_path__ + "img/2x3_blur.c6d07f38.jpg";